export default {
  zh: {
    rank: '排行',
    room: '房间',
    reward: '奖励',
    world: '世界',
    nation: '国家',
    rule: '规则',
    exRw: (v) => {
      return `每日赠送礼物金额达到${v}可获得奖励.`
    }
  },
  en: {
    rank: 'Ranking',
    room: 'Room',
    reward: 'Reward',
    world: 'World',
    nation: 'Nation',
    rule: 'Rule',
    exRw: (v) => {
      return `Rewards can be obtained when the daily gift amount reaches ${v}.`
    }
  },
  ar: {
    rank: 'الترتيب',
    room: 'غرفة',
    reward: 'مكافأة',
    world: 'العالم',
    nation: `دولة`,
    rule: 'القواعد',
    exRw: (v) => {
      return `سوف تحصل على المكافآت عندما يصل مبلغ الهدية الممنوحة اليومية إلى ${v}`
    }
  },
  tr: {
    rank: 'Ranking',
    room: 'Oda',
    reward: 'Geri çekil',
    world: 'Dünya',
    nation: 'Ulusal',
    rule: 'Kural',
    exRw: (v) => {
      return `Günlük hediye miktarı ${v}'e ulaştığında ödüllendirilebilir.`
    }
  },
  jp: {
    rank: 'ランキング',
    room: 'へや',
    reward: 'に報いる',
    world: '世界',
    nation: '国',
    rule: 'ルール＃ルール＃',
    exRw: (v) => {
      return `1日のプレゼント金額が${v}円に達すると奨励金がもらえます.`
    }
  },
  pt:{
    "rank": "Ranking",
    "room": "Sala",
    "reward": "Recompensa",
    "world": "Mundo",
    "nation": "Nação",
    "rule": "Regra",
    "exRw": (v) => {
      return `As recompensas podem ser obtidas quando a quantidade diária de presentes atingir ${v}.`
    }
},
    id:{
    "rank": "Peringkat",
    "room": "Ruang",
    "reward": "Hadiah",
    "world": "Dunia",
    "nation": "Negara",
    "rule": "Aturan",
    "exRw": (v) => {
      return `Hadiah dapat diperoleh ketika jumlah hadiah harian mencapai ${v}.`
    }
},
    uz:{
    "rank": "Reyting",
    "room": "Xona",
    "reward": "Mukofot",
    "world": "Dunyo",
    "nation": "Millat",
    "rule": "Qoidalar",
    "exRw": (v) => {
      return `Mukofotlar, kundalik sovg'a miqdori ${v} ga etganda olinadi.`
    }
},
    ru:{
    "rank": "Рейтинг",
    "room": "Комната",
    "reward": "Награда",
    "world": "Мир",
    "nation": "Нация",
    "rule": "Правило",
    "exRw": (v) => {
      return `Награды можно получить, когда сумма ежедневного подарка достигнет ${v}.`
    }
},

    fa:{
    "rank": "رتبه بندی",
    "room": "اتاق",
    "reward": "پاداش",
    "world": "جهان",
    "nation": "ملت",
    "rule": "قانون",
    "exRw": (v) => {
      return `پاداش‌ها زمانی قابل دریافت هستند که مبلغ هدیه روزانه به ${v} برسد.`
    }
}



}


// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/lang.js